import React from 'react';

class LegalGVW extends React.Component {
	constructor(props) {
		super(props)
		this.truck = this.props.truck;
	}

	render() {
		let bridgeWeights = this.truck.calculateBridgeWeights();

		// Get total truck axle weight
		let totalWeight = 0;
		for (let i = 0; i < this.truck.axleCount; ++i) {
			if (this.truck.steerable[i] == 'Yes') {
				totalWeight += (this.truck.tireRating[i] * this.truck.tireCount[i] * 2);
			} else {
				totalWeight += (this.truck.tireRating[i] * this.truck.tireCount[i]);
			}
			
		}

		return(
			<div className='gvw'>
				<h1>Legal GVW:</h1>
				<div className='gvwWeight'>
					<h1>{totalWeight} lbs.</h1>
					<h1>{totalWeight} lbs.</h1>
				</div>
				<div className='gvwWeightsLabels'>
					<h1>(9 Ton)</h1>
					<h1>(10 Ton)</h1>
				</div>
			</div>
			
		);
	}
}

export default LegalGVW;


// WEBPACK FOOTER //
// ./src/Minnesota/MNOutput/LegalGVW.js